import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WizardModel } from '../models/wizard.model';
import { WizardsService } from '../resources/wizards.service';

@Injectable()
export class ModelsBuilderService {
  constructor(private wizardsService: WizardsService) {}

  public buildModels(
    structures: Array<{ categories: any[]; models: any[] }>
  ): Observable<any> {
    return structures && structures.length
      ? this.wizardsService
          .list()
          .map((data) => (data ? data.data : []))
          .map((w) => {
            this.transformCategories(structures, w);
            return true;
          })
      : Observable.empty();
  }

  private transformCategories(
    structures: Array<{ categories: any[]; models: any[] }>,
    wizards: WizardModel[]
  ) {
    if (structures && Array.isArray(structures)) {
      structures
        .filter((s) => s.categories && s.categories.length > 0)
        .forEach((s) => {
          s.models = Array.from(
            s.categories.reduce((m: Set<any>, c: any) => {
              wizards
                .filter(
                  (w) =>
                    w.data.category &&
                    w.data.category.toLowerCase() === c.toLowerCase()
                )
                .forEach((w) => m.add(w.data.model));
              return m;
            }, new Set(s.models || []))
          );
        });
    }
  }
}
